import styled from 'styled-components';

export const StyledPictureList = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background: radial-gradient(transparent, black);
    mix-blend-mode: overlay;
    opacity: 0.65;
  }
`;

export const StyledPictureListItem = styled.picture`
  position: absolute;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  &.active {
    position: relative;
    z-index: 1;
    opacity: 1;
  }

  & > img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`